'use client';

import React from 'react';

import { cn } from '@/lib/utils';

import { useHLSPlayer } from '../contexts/hls-player-provider';
import FullscreenButton from './fullscreen-button';
import MoreOptions from './more-options';
import PlayPauseButton from './play-pause-button';
import SeekBar from './seek-bar';
import SpeedControl from './speed-control';
import TimeDisplay from './time-display';
import VolumeControl from './volume-control';

function ControlsContainer() {
	const { uiState, playbackState } = useHLSPlayer();
	const { showControls } = uiState;
	const { currentTime, duration } = playbackState;

	return (
		<div
			className={cn(
				'absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent pb-2 pt-8 transition-opacity duration-200',
				showControls ? 'opacity-100' : 'opacity-0'
			)}
		>
			{/* Seek bar */}
			<SeekBar className="mb-2" />

			{/* Controls row */}
			<div className="flex items-center px-4">
				<PlayPauseButton />
				<div className="flex items-center gap-1 px-1.5 text-white">
					<TimeDisplay time={currentTime} />
					<span className="text-xs text-white">/</span>
					<TimeDisplay time={duration} />
				</div>

				{/* Spacer */}
				<div className="flex-1" />

				<VolumeControl />
				<SpeedControl className="ml-1" />
				{uiState?.isFullscreen && <FullscreenButton />}
				<MoreOptions />
			</div>
		</div>
	);
}

export default React.memo(ControlsContainer);
